import gql from 'graphql-tag';

const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!, $tradename: String) {
    forgotPassword(email: $email, tradename: $tradename)
  }
`;

export {FORGOT_PASSWORD};
